import { render, staticRenderFns } from "./rateList.vue?vue&type=template&id=c7edbdb4&scoped=true"
import script from "./rateList.vue?vue&type=script&lang=js"
export * from "./rateList.vue?vue&type=script&lang=js"
import style0 from "./rateList.vue?vue&type=style&index=0&id=c7edbdb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7edbdb4",
  null
  
)

export default component.exports